import React from "react";
import * as Mui from "@mui/material";
import { Typography, Box, Stack } from "@mui/material";
import { CustomAutoCompleteWithStaticLabel } from "components/CustomComponents/CustomAutoCompleteWithStaticLabel";

const filterContainerStyles = {
  display: "flex",
  flexDirection: { xs: "column", sm: "row" },
  gap: 2,
  alignItems: { xs: "stretch", sm: "center" },
  flexWrap: "wrap",
  backgroundColor: "#fff",
  minHeight: "50px",
  px: 2,
  py: 1,
  borderRadius: "8px",
  border: "1px solid",
  borderColor: "#e0e0e0",
};

const filterLabelStyles = {
  fontWeight: 700,
  color: "text.secondary",
  textTransform: "uppercase",
  fontSize: "12px",
  letterSpacing: "1px",
  pr: { xs: 0, sm: 2 },
  pb: { xs: 1, sm: 0 },
  borderRight: { xs: "none", sm: "1px solid #e0e0e0" },
  borderBottom: { xs: "1px solid #e0e0e0", sm: "none" },
  minHeight: "24px",
  display: "flex",
  alignItems: "center",
};

const autocompleteStyles = {
  "& .MuiInputBase-root": {
    minHeight: "40px !important",
    borderRadius: "8px !important",
    backgroundColor: "#f5f7fa",
    border: "1px solid #00D4AA",
  },
  "& .MuiInputBase-input": {
    fontSize: "13px",
    fontWeight: 500,
    color: "#33475b",
    py: "10px",
    pl: "70px !important",
  },
  "& .MuiAutocomplete-endAdornment": {
    right: "8px !important",
  },
};

export const FilterSection = ({ filterLabel = "Filters", filters = [] }) => {
  return (
    <Mui.Box sx={filterContainerStyles}>
      <Typography variant="body2" sx={filterLabelStyles}>
        {filterLabel}
      </Typography>

      <Stack
        direction="row"
        spacing={2}
        useFlexGap
        flexWrap="wrap"
        sx={{ flex: 1, minWidth: 0, width: "100%", rowGap: 1.5 }}
      >
        {filters.map((filter, index) => (
          <Box
            key={index}
            sx={{ width: { xs: "100%", sm: filter.width || 250 } }}
          >
            {filter.component ? (
              filter.component
            ) : (
              <CustomAutoCompleteWithStaticLabel
                {...filter.props}
                sx={{ ...autocompleteStyles, ...filter.props?.sx }}
              />
            )}
          </Box>
        ))}
      </Stack>
    </Mui.Box>
  );
};
